import { ChartColumn } from "lucide-react";
import {
  LamaParticipationTrendParamsSchema,
  defaultLamaParticipationTrendParams,
  type LamaParticipationTrendOutput,
  type LamaParticipationTrendParams,
} from "@playbookai/widget-schemas";
import { lamaParamsEditor } from "../lama-report-params/Editor.js";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { LamaParticipationTrendWidget } from "./Component.js";

/**
 * LAMA Participation by Wave — dashboard-only report section (plan §13.3).
 * `TView` is the `lama/participation-trend@1` dataset output.
 */
export const lamaParticipationTrendDef: SqlWidgetDef<
  LamaParticipationTrendParams,
  LamaParticipationTrendOutput
> = {
  kind: "lamaParticipationTrend",
  label: "Participation by Wave",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 480, h: 280 },
  defaultParams: defaultLamaParticipationTrendParams,
  Component: LamaParticipationTrendWidget,
  storage: "sql",
  schema: LamaParticipationTrendParamsSchema,
  accent: "cyan",
  icon: ChartColumn,
  subtitle: "Coverage per wave",
  defaultRoster: false,
  category: "single",
  layout: { col: 1, row: 3, width: 480, height: 280 },
  dashboard: {
    icon: ChartColumn,
    defaultWidth: "wide",
    category: "Operations",
    supportsTitleOverride: true,
    EditorForm: lamaParamsEditor("lamaParticipationTrend"),
  },
};

registerWidget(lamaParticipationTrendDef);
